import type { ChWireQuestion } from "./caseHistoryWireTypes";
import {
  getWireVisibleIf,
  isFollowUpPanel,
  isPanel,
  wireChildElements,
  wireName,
  wireTitle,
} from "./caseHistoryWireTypes";
import { CaseHistoryWireQuestion } from "./CaseHistoryWireQuestion";
import { useWireAnswers } from "./wireAnswersContext";
import { evaluateWireVisibleIf } from "./evaluateWireVisibleIf";

export function CaseHistoryWireElements({ elements }: { elements: ChWireQuestion[] }) {
  const { answers } = useWireAnswers();

  return (
    <div>
      {elements.map((el, idx) => {
        const key = `${wireName(el) || "el"}-${idx}`;
        if (isPanel(el)) {
          const vis = getWireVisibleIf(el);
          if (vis && !evaluateWireVisibleIf(vis, answers)) {
            return null;
          }
          const children = wireChildElements(el);
          if (isFollowUpPanel(el)) {
            return (
              <div key={key} className="mb-4 ms-1 border-s-2 border-[#2A4064]/30 ps-4">
                <CaseHistoryWireElements elements={children} />
              </div>
            );
          }
          const t = wireTitle(el);
          return (
            <div key={key} className="mb-6">
              {t ? <h4 className="mb-3 text-[18px] font-extrabold text-[#1E252B]">{t}</h4> : null}
              <CaseHistoryWireElements elements={children} />
            </div>
          );
        }
        const visQ = getWireVisibleIf(el);
        if (visQ && !evaluateWireVisibleIf(visQ, answers)) {
          return null;
        }
        return <CaseHistoryWireQuestion key={key} question={el} />;
      })}
    </div>
  );
}
